import {BaseModel} from '@/core/standard/BaseModel';
import {GlobalSettingsProtocol, IGlobals, IGlobalSettingsModel} from '@/modules/settings/global/IGlobalSettingsModel';
import GlobalSettingServices from '@/modules/settings/global/GlobalSettingServices';


const globalSettings = {
  iva: '',
  language: '',
  new_request_sound: '',
  show_combined_aggregated_categories: false,
  currency: '',
  logo: '',
  use_touch_keyboard: true,
  select_employee_before_order: false,
  use_modifiers: false,
  show_category_name: false,
  use_payment_terminal: true,
  use_cashmatic: false,
  street: '',
  street_number: '',
  city: '',
  state: '',
  postal_code: '',
  reference: '',
  latitude: null,
  longitude: null,
  close_barra_order_auto: true,
  timezone: '',
};

// tslint:disable-next-line:max-line-length
class GlobalSettingsModel extends BaseModel<IGlobalSettingsModel, GlobalSettingsProtocol, typeof GlobalSettingServices> {
  public modelName = 'Configuracion Global';
  public request = 'FormData';

  constructor() {
    super(globalSettings, GlobalSettingServices);
  }

  public async create(data: FormData, toast: any, toastConfig: any) {
    if (!data.has('logo')) {
      data.append('logo', '');
    } else if (data.has('logo') && !(data.get('logo') instanceof File)) {
      data.delete('logo');
    }
    const request = await this.service.request({method: 'PUT', query: data});
    if (request.complete) {
      return this.handleSuccess(request.data, request.message, toast);
    } else {
      this.handleError(request, toast);
      return false;
    }
  }
}

export default GlobalSettingsModel as new() => IGlobals;


